<div class="content-wrapper max-width-wrapper" [class.iframe]="isIframe"
  [style]="'--corp-color-1: ' + (community?.colorBackground || community?.color1)">
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>

  <!-- Banner -->
  <app-banner *ngIf="community && community.code == 'gironahostaleria'"></app-banner>

</div>